export default {
    main: '0 1px 7px 0 rgba(33,38,44,.07)',
    paper: '0 4px 25px 0 rgba(0,0,0,.1)',
    sidebar: '0 4px 20px 0 rgba(0,0,0,.05)',
    navbar: '0 4px 20px 0 rgba(0,0,0,.05)'
}
